module.exports = __webpack_public_path__ + "img/user-icon.c4f51d14.svg";